import { PayoutAccountTypeEnum } from 'app/models';

export class PayoutAccountType {
    public static PayoutAccountTypeList: Array<any> = [
        { name: 'Bank', value: PayoutAccountTypeEnum.Bank },
        { name: 'E-Wallet', value: PayoutAccountTypeEnum.EWallet }
    ];
}
